import React from "react";

/**
 * Loader CSS-only ultra léger pour les Suspense fallbacks.
 * Aucune dépendance externe pour ne pas alourdir le chunk initial.
 */
export default function SuspenseLoader() {
    return (
        <div className="flex items-center justify-center w-full" style={{ height: "50vh" }}>
            <div
                className="animate-spin rounded-full border-4 border-gray-200"
                style={{
                    width: 40,
                    height: 40,
                    borderTopColor: "#6366f1",
                }}
            />
        </div>
    );
}
